const updateTableRows = (columnIndex, rowIndex, value, rows) => {
  rows[rowIndex][columnIndex] = value;
  return rows;
};

export default updateTableRows;
